interface StringDestinations {
	ISC: string;
	EXT: string;
	PZE: string;
	LEQ: string;
	NQY: string;
	LEQISC: string;
	ISCPZE: string;
	ISCLEQ: string;
	PZEISC: string;
}

interface StringRoutes {
	PZEISC: string;
	ISCPZE: string;
	LEQISC: string;
	ISCLEQ: string;
	STMLEQ: string;
	LEQSTM: string;
	EXTISC: string;
	ISCEXT: string;
	NQYISC: string;
	ISCNQY: string;
}

interface resourceCode {
	DIVA: string;
	CAMA: string;
	LUGA: string;
	BIKA: string;
	KAYA: string;
	BIKC: string;
	SRFA: string;
	BODA: string;
	PARK: string;
	BUS: string;
	WCHR: string;
	WCMP: string;
	WCBD: string;
	PETC: string;
	PAX: string;
}

export const resourceCode: resourceCode = {
	DIVA: "DIVA",
	CAMA: "CAMA",
	LUGA: "LUGA",
	BIKA: "BIKA",
	KAYA: "KAYA",
	BIKC: "BIKC",
	SRFA: "SRFA",
	BODA: "BODA",
	PARK: "PARK",
	BUS: "BUS",
	WCHR: "WCHR",
	WCMP: "WCMP",
	WCBD: "WCBD",
	PETC: "PETC",
	PAX: "PAX",
}

export const allresourceCodesources: string[] = [
	resourceCode.DIVA,
	resourceCode.CAMA,
	resourceCode.LUGA,
	resourceCode.BIKA,
	resourceCode.KAYA,
	resourceCode.BIKC,
	resourceCode.SRFA,
	resourceCode.BODA,
	resourceCode.PARK,
	resourceCode.BUS,
	resourceCode.WCHR,
	resourceCode.WCMP,
	resourceCode.WCBD,
	resourceCode.PETC,
	resourceCode.PAX
]

export const destinations: StringDestinations = {
	ISC: "ISC",
	EXT: "EXT",
	PZE: "PZE",
	LEQ: "LEQ",
	NQY: "NQY",
	LEQISC: "LEQISC",
	ISCPZE: "ISCPZE",
	PZEISC: "PZEISC",
	ISCLEQ: "ISCLEQ"
}

export const scillonianDestinationNames = {
	ISC: "St Mary's Harbour",
	PZE: "Penzance Harbour"
}

export const skybusDestinationNames = {
	ISC: "St Mary's Airport",
	EXT: "Exeter Airport",
	LEQ: "Land's End Airport",
	NQY: "Newquay Airport",
}

export const flyAndSailDestinationNames = {
	LEQISC: "Land's End Airport > St Mary's Airport",
	ISCPZE: "St Mary's Harbour > Penzance Harbour"
}

export const sailAndFlyDestinationNames = {
	PZEISC: "Penzance Harbour > St Mary's Harbour",	
	ISCLEQ: "St Mary's Airport > Land's End Airport"
}

export const stringRoutes: StringRoutes = {
	PZEISC: "PZEISC",
	ISCPZE: "ISCPZE",
	LEQISC: "LEQISC",
	ISCLEQ: "ISCLEQ",
	STMLEQ: "STMLEQ",
	LEQSTM: "LEQSTM",
	EXTISC: "EXTISC",
	ISCEXT: "ISCEXT",
	NQYISC: "NQYISC",
	ISCNQY: "ISCNQY"
}

//Scillonian and Skybys route translations
export const routeTranslations = [
	{ code: stringRoutes.PZEISC, name: "Penzance Harbour - St Mary's Harbour" },
	{ code: stringRoutes.ISCPZE, name: "St Mary's Harbour - Penzance Harbour" },
	{ code: stringRoutes.LEQISC, name: "Land's End Airport - St Mary's Airport" },
	{ code: stringRoutes.ISCLEQ, name: "St Mary's Airport - Land's End Airport" },
	{ code: stringRoutes.EXTISC, name: "Exeter Airport - St Mary's Airport" },
	{ code: stringRoutes.ISCEXT, name: "St Mary's Airport - Exeter Airport" },
	{ code: stringRoutes.NQYISC, name: "Newquay Airport - St Mary's Airport" },
	{ code: stringRoutes.ISCNQY, name: "St Mary's Airport - Newquay Airport" }
]

//Fly and Sail route translations
export const flyAndSailRouteTranslations = [
	{ code: stringRoutes.LEQISC, name: "Land's End Airport > St Mary's Airport" },
	{ code: stringRoutes.ISCPZE, name: "St Mary's Harbour > Penzance Harbour" }
]

//Sail and fly route translations
export const sailAndFlyRouteTranslations = [
	{ code: stringRoutes.PZEISC, name: "Penzance Harbour > St Mary's Harbour" },
	{ code: stringRoutes.ISCLEQ, name: "St Mary's Airport > Land's End Airport" }
]

export const allDestinations: string[] = [
	destinations.ISC,
	destinations.EXT,
	destinations.PZE,
	destinations.LEQ,
	destinations.NQY,
	destinations.LEQISC,
	destinations.ISCPZE,
	destinations.PZEISC,
	destinations.ISCLEQ
]

export const routesFromIsland: string[] = [
	stringRoutes.ISCPZE,
	stringRoutes.ISCLEQ,
	stringRoutes.ISCEXT,
	stringRoutes.ISCNQY
]